<template>
  <div id="app" v-cloak>
    <back v-if="
      ((!!$route.query.header_type &&
        $route.query.header_type !== HeaderType.HideHeader &&
        (($route.meta.common && !$route.meta.home) ||
          ($route.meta.common && $route.meta.home && $route.query.header_type === HeaderType.Header))) ||
        $route.name === 'rankList') &&
      encludePage
    " :darkbg1="darkbg" />
    <transition :name="transitionName">
      <keep-alive include="ring-zone,ringtone-topic,search-page,recommond-list,tab-home,topic-list-details,miguBJYH,miguBJYH-ringzone">
        <router-view></router-view>
      </keep-alive>
    </transition>
  </div>
</template>
<script>
import dark from '@/mixins/dark'
import { h5DarkChange, KeyboardUp, getUserInfo, isAllowedPrivacy } from '@/utils/bridge.js'
import { track } from '@/directives/track/send.js'
import { HeaderType } from '@/model/HeaderType'
import { CarrierType } from './model/CarrierType'
import { PcidType } from '@/model/PcidType'
import { parseUrlParams, getUidByUrl } from '@/utils/index.ts'
import { Toast } from 'vant'
export default {
  name: 'App',
  mixins: [dark],
  components: {
    back: () => import('@/components/header.vue')
  },
  props: {},
  data () {
    return {
      time: Date.now(),
      message: '',
      loadTime: null,
      transitionName: '',
      HeaderType: Object.freeze(HeaderType)
    }
  },
  computed: {
    carrierType () {
      return this.$store.state.ringtone.carrierType
    },
    encludePage () {
      const routes = ['ring-zone', 'recommond-list', 'ringtone-topic', 'diy', 'topic-list-details', 'miguBJYH', 'miguBJYH-ringzone']
      return !routes.includes(this.$route.name)
    },
    isPayChannel () {
      const curerntPageParams = parseUrlParams(location.href)
      const isPayChannel = PcidType.Apps.includes(this.$route.query.pcid) && Object.keys(curerntPageParams).includes('actorName')
      return isPayChannel
    }
  },
  watch: {
    $route: {
      handler: function (route, oldRoute) {
        Toast.clear()
        if (oldRoute) {
          window.$referrer = location.origin + '/#' + oldRoute.fullPath
        }
        if (route.name) {
          if (this.loadTime) {
            this.loadTime = Date.now()
          } else {
            // this.loadTime = window.loadTime
            this.loadTime = Date.now()
          }
        }
        this.time = Date.now()

        // 处理页面条状路由动画效果
        let to, from
        if (route) to = route.meta.pageIndex
        if (oldRoute) from = oldRoute.meta.pageIndex
        if (!oldRoute) {
          this.transitionName = ''
        } else {
          if (route.name === oldRoute.name || !oldRoute.name) {
            this.transitionName = ''
          } else {
            if (to < from) {
              // 设置动画名称 出来是从左往右
              this.transitionName = 'slide-right'
            } else {
              // 进去是从右往左
              this.transitionName = 'slide-left'
            }
          }
        }

        if (route.name) {
          if (this.loadTime) {
            this.loadTime = Date.now()
          } else {
            this.loadTime = window.loadTime
          }
          this.$nextTick(() => {
            track([
              {
                event_id: '$WebPageLoad',
                event_param: {
                  $event_duration: (Date.now() - this.loadTime) / 1000,
                  content_type: '视频彩铃',
                  content_id: '',
                  content_name: route.meta.name
                }
              }
            ])
          })
        }
        if (
          (route.name === 'details' && oldRoute.name !== 'details') ||
          route.name === 'ringtone-topic' ||
          route.name === 'recommond-list' ||
          route.name === 'introduce-video' ||
          route.name === 'search-page' ||
          route.name === 'diy-details' ||
          route.name === 'diy-home' ||
          route.name === 'diy-input-phone' ||
          route.name === 'topic-list-details'

        ) {
          if (window.system) {
            window.system.postMessage('hideMenutabar')
          }
        } else if (route.name === 'ring-zone') {
          if (window.system) {
            window.system.postMessage('homeTabar')
          }
        }
        if (window.system) {
          const tem = {
            oldRoute: oldRoute && oldRoute.name ? oldRoute.name : '',
            newRoute: route.name
          }
          window.system.postMessage(JSON.stringify(tem))
        }
      },
      immediate: true
    }
  },
  created () {
    console.log(this.$os16)
    debugger
    this.getUserInfo()
    const that = this
    h5DarkChange((data, responseCallback) => {
      localStorage.setItem('bgColor', JSON.parse(data).bgColor)
      that.$store.commit('app/SET_DARKBG', JSON.parse(data).dark)
      that.$store.commit('app/SET_DARKCOLOR', '#' + JSON.parse(data).bgColor)
      const responseData = data
      responseCallback(responseData)
    })
    isAllowedPrivacy()
      .then(res => {
        const data = JSON.parse(res)
        this.$store.commit('app/SET_IS_ALLOWED_PRIVACY', data.isAllowedPrivacy)
      })

    try {
      const itemstr = window.sessionStorage.getItem('processConfig')
      const obj = JSON.parse(itemstr)
      this.$store.commit('app/SET_PROCESS_CONFIG_DATA', obj)
    } finally {
      window.sessionStorage.removeItem('processConfig')
    }

    if (window.system) {
      window.system.onmessage = function (tem) {
        const data = JSON.parse(tem)
        that.message = tem

        if (data.type === 'route') {
          const query = {
            ...that.$route.query
          }
          if (data.message === 'personal') {
            delete query.title

            if (!window.KuYinExt && !that.$store.state.app.loginStatus) {
              that.$router.push({
                name: 'login-acount',
                query
              })
            } else {
              that.$router.push({
                name: data.message,
                query
              })
            }
          } else {
            that.$router.push({
              name: data.message,
              query
            })
          }
        } else if (data.type === 'themeMode') {
          that.$store.commit('app/SET_DARKBG', data.message.darkbg)
          that.$store.commit('app/SET_DARKCOLOR', data.message.darkColor)
        }
      }
    }
    let flag = false
    if (window.KuYinExt && window.KuYinExt.isLogin && window.KuYinExt.isLogin()) {
      const isLogin = window.KuYinExt.isLogin()
      if (typeof isLogin === 'boolean') {
        flag = isLogin
      } else {
        // 判断uid
        const params = getUidByUrl()
        if (params.uid) {
          flag = true
        }
      }
    }
    // todo 判断要不要主题展示一键授权手机号按钮
    const curerntPageParams = parseUrlParams(location.href)
    if (flag && curerntPageParams.pcid && !(curerntPageParams.pcid.startsWith('ot'))) {
      this.$store.commit('app/SET_HUAN_TAI_ISLOGIN', true)
    }

    // // 主题默认展示
    // if (curerntPageParams.pcid && (curerntPageParams.pcid.startsWith('ot'))) {
    //   if (window.ThemeClient && window.ThemeClient.isLogin()) {
    //     this.$store.commit('app/SET_HUAN_TAI_ISLOGIN', true)
    //   } else {
    //     this.$store.commit('app/SET_HUAN_TAI_ISLOGIN', false)
    //   }
    // }

    const userInfo = localStorage.getItem('userInfo')
    const userInfo1 = sessionStorage.getItem('userInfo')
    if (!userInfo && !userInfo1) {
      this.$store.commit('ringtone/SET_CARRIER_TYPE', CarrierType.MIGU)
      this.$store.commit('ringtone/SET_SOURCE_CHANGE', '')
    }
  },

  mounted () {
    KeyboardUp()

    const sensors = window.sensorsDataAnalytic201505
    const presetProperties = sensors.getPresetProperties()
    const cookieId = presetProperties.identities.$identity_cookie_id

    const curerntPageParams = parseUrlParams(location.href)
    if (PcidType.OppoThemes.includes(curerntPageParams.pcid)) {
      const pid = window.localStorage.getItem('pid')
      const selfInfo = {
        uid: '',
        token: '',
        'dev-brand': '',
        'dev-manufacturer': '',
        'dev-model': '',
        'dev-language': '',
        'dev-region': '',
        'dev-timezone': '',
        'dev-app-version': '',
        'dev-channel': '',
        'dev-package': '',
        'dev-id': '',
        'dev-pid': pid
      }
      this.$store.commit('app/SET_SELFINFO', selfInfo)
    }

    this.$store.commit('app/SET_COOKIEID', cookieId)
  },
  methods: {
    getUserInfo () {
      getUserInfo().then(responseData => {
        this.$store.commit('app/SET_SELFINFO', responseData)
      })
    }

  }
}
</script>

<style lang="scss">
@import "@/assets/css/_handle.scss";

html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
}

#app {
  // font-family: "opSansRe";
  width: 100%;
  height: 100%;
  // overflow-x: hidden;
  position: relative;
  //  @include background_color("background_color");
}

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 500ms;
  position: absolute;
  top:0
}

.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}

.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
</style>
